import { createRouterReducer } from '@lagunovsky/redux-react-router'
import { combineReducers } from 'redux'

import componentsReducer from '../components/reducer'
import i18nSlice from '../global/i18n/reducer'
import pagesReducer from '../pages/reducer'
import servicesReducer from '../services/reducer'
import tokenSlice from '../services/token/reducer'

/*
    Root reducer for all application slices/reducers
    Put any slices/reducers into this object 
*/
const createRootReducer = (history) =>
    combineReducers({
        pages: pagesReducer,
        components: componentsReducer,
        services: servicesReducer,
        i18n: i18nSlice,
        navigator: createRouterReducer(history),
        token: tokenSlice,
    })

export default createRootReducer
